import { createSlice } from '@reduxjs/toolkit'

export const Package = createSlice({
    name: 'package',
    initialState : {
        packages : {
            current_page : 0,
            data : [],
            first_page_url : "",
            from : null,
            last_page : 0,
            last_page_url : "",
            links : [],
            next_page_url: null,
            path: "",
            per_page: 12,
            prev_page_url: null,
            to: null,
            total: 0
        },
        package : null
    },
    reducers: {
        setPackages(state,action) {
          state.packages = action.payload;
        },
        setPackage (state,action) {
            state.package = action.payload;
        },
    },
})

// Action creators are generated for each case reducer function
export const { setPackages , setPackage } = Package.actions

export default Package.reducer